import React, { useEffect, useState } from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Tooltip from "@mui/material/Tooltip";
import {
  PurchasePaymentList1,
  PurchasePaymentUUID1,
} from "../../services/Purchase/PurchaseService";
import { Link, useNavigate } from "react-router-dom";
import { logPurchasePaymentHistory } from "../../services/index"
import Modal from "react-bootstrap/Modal";
import { searchForMatch } from '../utils/textUtils'
import Loader from "../Common/Loader";

const PayPurchaseList = () => {
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [logData, setLogData] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const [dataId, setDataId] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;

  const columns = [
    {
      name: "PAYMENT NO#",
      selector: (data) => data.paymentNo,
    },
    {
      name: "VENDOR NAME",
      selector: (data) => data.vendorTitle,
    },

    {
      name: "BILL NO#",
      selector: (data) => data.billNo,
    },

    {
      name: "DATE",
      selector: (data) => data.paymentDate,
    },

    {
      name: "AMOUNT",
      selector: (data) => parseFloat(data.amountReceived).toFixed(2),
    },
  ];

  const InvoicesList = () => {
    let list_data = {
      page: 0,
      size: -1,
      search: "",
    };
    setLoading(true)
    PurchasePaymentList1(list_data)
      .then((res) => {
        if (res.errorCode == 0) {
          const d = res.responsePacket.data;
          setData(d);
          setFilteredData(d);
          setLoading(false)
        } else {
          toast.error(res.message,);
          setLoading(false)
        }
      }).catch(error=> setLoading(false))

  };



  useEffect(() => {
    InvoicesList();
  }, [page]);

  useEffect(() => {
    const result = data.filter((data) => {
      return searchForMatch(data.vendorTitle, search)
    });
    setFilteredData(result);
  }, [search]);



  const handleModel = (id) => {
    handleShow();
    logPurchasePaymentHistory(id).then((res) => {
      if (res.errorCode == 0) {
        const d = res.responsePacket;
        setLogData(d);
      } else {
        toast(res.message);
      }
    });
  };

  return (
    <>

      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          Log History
          <hr />
          <table>
            {logData.length == 0 ? (
              "No Changes Found"
            ) : (
              <tr>
                <td>Date</td>
                <td>Changes</td>
              </tr>
            )}
            {logData.length >= 1 &&
              logData?.map((history) => {
                return (
                  <>
                    <tr>
                      <td style={{ verticalAlign: "top" }}>
                        {history?.transactionDate?.substring(0, 10)}:&nbsp;&nbsp;
                      </td>

                      <td>
                        {history?.message.split("\n").map((b, i) => (
                          <tr>
                            {b.includes("\t") ? (
                              <div style={{ marginLeft: "20px" }}>{b}</div>
                            ) : b.includes("\t\t") ? (
                              <div style={{ marginLeft: "40px" }}>{b}</div>
                            ) : (
                              b
                            )}
                          </tr>
                        ))}
                      </td>
                    </tr>
                    <hr />
                  </>
                );
              })}
          </table>
        </Modal.Body>
      </Modal>

      <div className="column list-column expanded-list-column">
        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            title="All Payments"
            defaultSortAsc={false}
            defaultSortFieldId={1}
            columns={columns}
            data={filteredData}
            pagination

            fixedHeader
            pointerOnHover={true}
            highlightOnHover={true}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page)}
            onRowClicked={(data) => {
              handleModel(data.recordId);
            }}
            progressPending={loading}
            progressComponent={<Loader />}

            subHeader
            subHeaderComponent={
              <><SearchRoundedIcon />
                <input autoComplete="off"
                  className="ember-text-field ember-view form-control col-2"
                  type="text"
                  placeholder={"Search here"}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                /></>
            }

          />

        </div>

        <Toaster />
      </div>
    </>
  );
};

export default PayPurchaseList;
